import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import validator from 'validator';

var ComboCodeValidator = /*#__PURE__*/function () {
  function ComboCodeValidator(validations) {
    _classCallCheck(this, ComboCodeValidator); // validations is an array of validation rules specific to a form


    this.validations = validations;
  }

  _createClass(ComboCodeValidator, [{
    key: "validateSubmitData",
    value: function validateSubmitData(state) {
      // start out assuming valid
      var validation = this.valid(); // for each validation rule

      this.validations.forEach(function (rule) {
        // if the field hasn't already been marked invalid by an earlier rule
        if (!validation[rule.field].isInvalid) {
          // determine the field value, the method to invoke and optional args from
          // the rule definition
          var field_value = state[rule.field].toString();
          var args = rule.args || [];
          var validation_method = typeof rule.method === 'string' ? validator[rule.method] : rule.method; // call the validation_method with the current field value as the first
          // argument, any additional arguments, and the whole state as a final
          // argument.  If the result doesn't match the rule.validWhen property,
          // then modify the validation object for the field and set the isValid
          // field to false

          if (validation_method.apply(void 0, [field_value].concat(_toConsumableArray(args), [state])) !== rule.validWhen) {
            validation[rule.field] = {
              isInvalid: true,
              message: rule.message
            };
            validation.isValid = false;
          }
        }
      });
      return validation;
    }
  }, {
    key: "valid",
    value: function valid() {
      var validation = {};
      this.validations.map(function (rule) {
        return validation[rule.field] = {
          isInvalid: false,
          message: ''
        };
      });
      return _objectSpread({
        isValid: true
      }, validation);
    }
  }]);

  return ComboCodeValidator;
}();

export default ComboCodeValidator;